import { ConfigProvider } from 'antd';

import { Embed } from './components/Embed';
import { FAQ } from './components/FAQ';
import { Features } from './components/Features';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { Hero } from './components/Hero';
import { HowItWorks } from './components/HowItWorks';
import { Navbar } from './components/Navbar';
import { Pricing } from './components/Pricing';
import { Problem } from './components/Problem';
import { Security } from './components/Security';
import { Trust } from './components/Trust';

import './styles/landing.less';

export function LandingPage() {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#1677ff',
          borderRadius: 12,
        },
        components: {
          Card: {
            paddingLG: 24,
            colorBorderSecondary: 'rgba(0, 0, 0, 0.08)',
          },
          Collapse: {
            headerPadding: '16px 24px',
            contentPadding: '16px 24px',
          },
        },
      }}
    >
      <div className="rebranded-landing-root">
        <Navbar />
        <Hero />
        <Trust />
        <Problem />
        <Features />
        <HowItWorks />
        <Embed />
        <Pricing />
        <Security />
        <FAQ />
        <FinalCTA />
        <Footer />
      </div>
    </ConfigProvider>
  );
}

export default LandingPage;
